import axios from 'axios';

// Set base URL globally
const api = axios.create({
  baseURL: 'https://api.froz.dzyris.in'
});

export default api;
